// extracted by mini-css-extract-plugin
export default {"input":"CustomInput_input__jvwsu","medium":"CustomInput_medium__aouU-"};